<template>
  <NEl class="about-dialog">
    <div class="overlay"></div>
    <div class="content">
      <NIcon class="logo" :size="60">
        <AppLogo></AppLogo>
      </NIcon>
      <div class="title">{{ t(I18nKeys.system.aboutTitle) }}</div>
      <div class="version">
        {{ t(I18nKeys.system.currentVersion) + ' ' + globalStore.appVersion }}
      </div>
      <div class="copyright">{{ IS_INTL ? t(I18nKeys.system.copyright) : t(I18nKeys.system.copyrightLocal) }}</div>
      <NButton v-if="!newVersion" class="update-button" type="primary" :loading="isCheckingUpdate" :disabled="checkedUpdate" size="large" @click="checkUpdate">
        {{ checkedUpdate ? t(I18nKeys.system.noUpdateMessage) : t(I18nKeys.system.checkUpdateButtonText) }}
      </NButton>
      <NButton v-else class="update-button" type="primary" :loading="isCheckingUpdate" size="large" @click="update">
        {{ t(I18nKeys.system.updateButtonText, { version: newVersion }) }}
      </NButton>
      <NIcon class="close-icon" :size="43" @click="emit('close')">
        <IosClose></IosClose>
      </NIcon>
    </div>
  </NEl>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { I18nKeys } from '@/constants/i18n'
import { NEl, NIcon, NButton } from 'naive-ui'
import { IosClose } from '@vicons/ionicons4'
import AppLogo from '@/components/icons/AppLogo.vue'
import { useGlobalStore } from '@/stores/global'
import { computed, onMounted, ref, watch } from 'vue'
import { IS_INTL } from '@/constants/global'

const { t } = useI18n()

const emit = defineEmits(['close'])

const globalStore = useGlobalStore()

const newVersion = ref('')
const checkedUpdate = ref(false)
const isCheckingUpdate = computed({
  get: () => globalStore.isCheckingUpdate,
  set: (value) => globalStore.setIsCheckingUpdate(value)
})
const checkUpdate = async () => {
  if (isCheckingUpdate.value) return

  isCheckingUpdate.value = true
  checkedUpdate.value = false
  try {
    // @ts-ignore
    const result = await electronAPI.checkUpdate()
    console.info('checkUpdate result', result)
    if (!result) {
      isCheckingUpdate.value = false
    }
  } catch (error) {
    console.error('Error checking update', error)
    isCheckingUpdate.value = false
  }
}
const update = async () => {
  isCheckingUpdate.value = true
  try {
    // @ts-ignore
    await electronAPI.doUpdate()
  } catch (error) {
    console.error('Error updating', error)
  }
}
watch(isCheckingUpdate, async (value) => {
  if (!value) {
    checkedUpdate.value = true
    // @ts-ignore
    const version = await electronAPI.getNewVersion()
    console.info('new version', version)
    console.info('current version', globalStore.appVersion)
    if (version && version > globalStore.appVersion) {
      newVersion.value = version
    }
  }
}, { immediate: true })

onMounted(async() => {
  // @ts-ignore
  isCheckingUpdate.value = await electronAPI.getCheckingUpdate()
  checkUpdate()
})
</script>
<style scoped>
.about-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;

  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 360px;
    background-color: var(--base-color);
    border-radius: 10px;
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .close-icon {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      color: #b0b2ae;
    }

    .logo {
      margin-bottom: 20px;
    }

    .title {
      font-size: 18px;
      font-weight: 600;
      color: var(--text-color-base);
      margin-bottom: 10px;
    }

    .version {
      font-size: 14px;
      color: var(--text-color-base);
      margin-bottom: 40px;
    }

    .copyright {
      font-size: 12px;
      color: var(--text-color-3);
      margin-bottom: 20px;
    }

    .update-button {
      min-width: 80%;
    }
  }
}
</style>
